import React from 'react'
import { Cell } from 'rsuite-table'
import './CampaignStatus.scss'

type RowData = {
  [key: string]: string | boolean
}

type CampaignStatusCellProps = {
  rowData?: RowData,
  dataKey: string
}

const CampaignStatusCell: React.FC<CampaignStatusCellProps> = ({
  rowData,
  dataKey,
  ...props
}) => {
  const status = rowData?.[dataKey]
  const lowerCaseStatus = typeof status === 'string' ? status.toLowerCase() : ''
  const allowedStatuses = ['schedule', 'draft', 'cancel', 'process']

  if (!allowedStatuses.includes(lowerCaseStatus)) {
    return (
      <Cell {...props}>
        <span className="status-blank">-</span>
      </Cell>
    )
  }

  let statusClass = ''
  if (lowerCaseStatus === 'schedule') {
    statusClass = 'status-schedule'
  } else if (lowerCaseStatus === 'draft') {
    statusClass = 'status-draft'
  } else if (lowerCaseStatus === 'cancel') {
    statusClass = 'status-cancel'
  } else if (lowerCaseStatus === 'process') {
    statusClass = 'status-process'
  }

  return (
    <Cell {...props}>
      <span className={`status-cell ${statusClass}`}>{status}</span>
    </Cell>
  )
}

export default CampaignStatusCell
